
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-automation",
      function () {
        return require("private-next-pages/whatsapp-automation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-automation"])
      });
    }
  